/**
 * Branded UUID types and schemas for cross-vertical IDs.
 * Per docs/DATA-MODEL.md, every entity uses opaque UUIDs as primary keys.
 */
import { z } from 'zod';
export const UuidSchema = z.string().uuid();
export const DeviceIdSchema = UuidSchema.transform((v) => v);
export const UserIdSchema = UuidSchema.transform((v) => v);
export const SellerIdSchema = UuidSchema.transform((v) => v);
export const FirmwareVersionIdSchema = UuidSchema.transform((v) => v);
export const RolloutIdSchema = UuidSchema.transform((v) => v);
export const ShareIdSchema = UuidSchema.transform((v) => v);
export const DeviceConfigIdSchema = UuidSchema.transform((v) => v);
//# sourceMappingURL=id.js.map